import { useQuery } from 'react-query';
import { getProhibitedOperations } from '../api';

const useGetProhibitedOperations = (akHash?: string) => {
  return useQuery(['prohibited_operations', akHash], () => getProhibitedOperations(akHash), {
    enabled: Boolean(akHash),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    select: (data) => data.prohibitedOperations,
  });
};

export default useGetProhibitedOperations;
